import * as turf from "@turf/turf";
import { toEPSG5186, toWGS84 } from "./pathConnector";
// 폴리곤 회전 각도 계산 함수
export function polygonOrientation(coords) {
  let maxLen = 0;
  let angle = 0;

  for (let i = 0; i < coords.length - 1; i++) {
    const [x1, y1] = coords[i];
    const [x2, y2] = coords[i + 1];

    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.sqrt(dx * dx + dy * dy);

    if (len > maxLen) {
      maxLen = len;
      angle = Math.atan2(dy, dx); // 라디안 단위
    }
  }

  // 도(degrees)로 변환
  return (angle * 180) / Math.PI;
}

// 폴리곤 회전 함수
export function rotatePoint(p, pivot, deg) {
  const rad = (deg * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const dx = p[0] - pivot[0];
  const dy = p[1] - pivot[1];
  return [pivot[0] + dx * cos - dy * sin, pivot[1] + dx * sin + dy * cos];
}

// 두 점의 중점 계산
export function midpointCartesian(p1, p2) {
  const [x1, y1] = p1;
  const [x2, y2] = p2;
  return [(x1 + x2) / 2, (y1 + y2) / 2];
}

// 코너 필터링 함수
export function filterCorner(p1, p3, p2, p4, R, numSamples) {
  // p1, p2점 까지의 방향각 (라디안)
  const D1 = Math.atan2(-(p2[1] - p1[1]), p2[0] - p1[0]);
  // p2, p3점 까지의 방향각 (라디안)
  const D2 = Math.atan2(-(p3[1] - p2[1]), p3[0] - p2[0]);
  // 두 방향각의 차이를 통한 꺾인 각도 산출 (라디안)
  let dD = D2 - D1;

  // -π ~ π 범위로 정규화
  while (dD > Math.PI) dD -= 2 * Math.PI;
  while (dD < -Math.PI) dD += 2 * Math.PI;

  const halfAngle = dD / 2;
  const offsetDist = R / Math.tan(Math.abs(halfAngle));

  // 원호 중심
  const bisectorAngle = D1 + halfAngle;
  const center = [
    p2[0] - (R / Math.sin(Math.abs(halfAngle))) * Math.cos(bisectorAngle),
    p2[1] + (R / Math.sin(Math.abs(halfAngle))) * Math.sin(bisectorAngle),
  ];

  const startAngle = D1 + (Math.sign(dD) * Math.PI) / 2;
  const endAngle = D2 - (Math.sign(dD) * Math.PI) / 2;
  const arcCoords = [];
  const angleDiff = endAngle - startAngle;

  for (let i = 0; i <= numSamples; i++) {
    const t = i / numSamples;
    const a = startAngle + angleDiff * t;
    arcCoords.push([center[0] + R * Math.cos(a), center[1] - R * Math.sin(a)]);
  }

  return arcCoords;
}

export function PointInPolygonCheck(
  headlandData,
  movePoint,
  current,
  forwardDist,
  bearingDegrees
) {
  const headlandCoordsWGS84 = headlandData.headland.map((coord) =>
    toWGS84(coord)
  );
  const headlandPolygon = turf.polygon([headlandCoordsWGS84]);

  const p1_x = movePoint(current.at(-1), forwardDist, bearingDegrees - 30);
  const p2_x = movePoint(p1_x, forwardDist, bearingDegrees + 20);
  const p3_x = movePoint(
    p2_x,
    Number(forwardDist) + Number(forwardDist),
    bearingDegrees - 155
  );
  const p4_x = movePoint(p3_x, Number(forwardDist) / 2, bearingDegrees + 60);

  // p1_x를 WGS84로 변환
  const p1_xWGS84 = toWGS84(p1_x);
  const p1_xWGS84Point = turf.point(p1_xWGS84);

  const p2_xWGS84 = toWGS84(p2_x);
  const p2_xWGS84Point = turf.point(p2_xWGS84);

  const p3_xWGS84 = toWGS84(p3_x);
  const p3_xWGS84Point = turf.point(p3_xWGS84);

  const p4_xWGS84 = toWGS84(p4_x);
  const p4_xWGS84Point = turf.point(p4_xWGS84);

  let isInside1 = turf.booleanPointInPolygon(p1_xWGS84Point, headlandPolygon);
  let isInside2 = turf.booleanPointInPolygon(p2_xWGS84Point, headlandPolygon);
  let isInside3 = turf.booleanPointInPolygon(p3_xWGS84Point, headlandPolygon);
  let isInside4 = turf.booleanPointInPolygon(p4_xWGS84Point, headlandPolygon);

  return isInside1 || isInside2 || isInside3 || isInside4;
}
